import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React from "react";
import { css } from "styled-components";

const fulldWidthPageStyles = {
    css: css`
        padding-bottom: 1em;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0 20px 1em 20px;
                `,
                css`
                    padding: 0 20px 1em 20px;
                `,
                css``,
                css``,
                css``,
            ])}
    `,
};

const FullWidthPage = ({ id }: PageProps) => (
    <Page padding={0} fullWidth={[false, false, true, true, true]}>
        <StyledWrapper {...fulldWidthPageStyles}>
            <Zone contentId={id} zoneName="Content"></Zone>
        </StyledWrapper>
    </Page>
);

const pageModule: PageModule = {
    component: FullWidthPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
        pageType: "Content",
    },
};

export default pageModule;
